import PaymentForm from './PaymentForm.jsx'
import {
  Elements
} from '@stripe/react-stripe-js'
import React, { useState } from 'react'
import NormalForm from './NormalForm.jsx';

function BookingConfirmation({ 
  customerInfo, 
  onCustomerInfoChange, 
  onConfirmBooking, 
  selectedService, 
  selectedWorker, 
  selectedDate, 
  selectedTime,
  clientSecret,
  stripePromise,
  businessId,
  paymentCompleted,
  onPaymentCompleted,
  showPaymentForm
}) { 

  return (
    <>
    {!showPaymentForm ? (
          <div className="booking-step">
            <h2>Confirm Your Booking</h2>
            <div className="booking-confirmation-layout">
              <div className="booking-summary-column">
                <div className="summary-card">
                  <h3>Booking Summary</h3>
                  <div className="summary-item">
                    <span><strong>Service:</strong></span>
                    <span>{selectedService?.service || selectedService?.service_name}</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Duration:</strong></span>
                    <span>{selectedService?.duration} minutes</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Stylist:</strong></span>
                    <span>{selectedWorker?.name}</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Date:</strong></span>
                    <span>{new Date(selectedDate).toLocaleDateString('en-US', { 
                      weekday: 'long', 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Time:</strong></span>
                    <span>{selectedTime}</span>
                  </div>
                  {selectedService?.has_deposit && (
                    <div className="summary-item">
                      <span><strong>Deposit:</strong></span>
                      <span>{selectedService?.deposit_fraction * 100}% * £{selectedService?.price} = £{(selectedService?.price * selectedService?.deposit_fraction).toFixed(2)}</span>
                    </div>
                  )}
                  {selectedService.price > 0 && (
                    <div className="summary-item total">
                      <span><strong>Total:</strong></span>
                      <span>£{ selectedService?.has_deposit? (selectedService?.price * selectedService?.deposit_fraction).toFixed(2) : selectedService?.price.toFixed(2)}</span>
                    </div>
                  )}

                </div>
              </div>
              
              <div className="customer-info-column">
                  <NormalForm onCustomerInfoChange={onCustomerInfoChange} customerInfo={customerInfo} onConfirmBooking={onConfirmBooking} businessId={businessId} serviceId={selectedService?.id} />
              </div>
            </div>
          </div>
    ) : !stripePromise ? (
        <div className="booking-step">
          <h2>Confirm Your Booking</h2>
          <div className="error-payment">
            <p>Payment system is not available. Please check configuration.</p>
            <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
              Missing REACT_APP_STRIPE_PUBLISHABLE_KEY environment variable.
            </p>
          </div>
        </div>
      ) : clientSecret ? (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <div className="booking-step">
            <h2>Confirm Your Booking</h2>
            <div className="booking-confirmation-layout">
              <div className="booking-summary-column">
                <div className="summary-card">
                  <h3>Booking Summary</h3>
                  <div className="summary-item">
                    <span><strong>Service:</strong></span>
                    <span>{selectedService?.service || selectedService?.service_name}</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Duration:</strong></span>
                    <span>{selectedService?.duration} minutes</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Worker:</strong></span>
                    <span>{selectedWorker?.name}</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Date:</strong></span>
                    <span>{new Date(selectedDate).toLocaleDateString('en-US', { 
                      weekday: 'long', 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}</span>
                  </div>
                  <div className="summary-item">
                    <span><strong>Time:</strong></span>
                    <span>{selectedTime}</span>
                  </div>
                  {selectedService?.has_deposit && (
                    <div className="summary-item">
                      <span><strong>Deposit:</strong></span>
                      <span>{selectedService?.deposit_fraction * 100}% * £{selectedService?.price} = £{(selectedService?.price * selectedService?.deposit_fraction).toFixed(2)}</span>
                    </div>
                  )}
                  {selectedService.price > 0 || !selectedService.has_deposit && (
                    <div className="summary-item total">
                      <span><strong>Total:</strong></span>
                      <span>£{ selectedService?.has_deposit? (selectedService?.price * selectedService?.deposit_fraction).toFixed(2) : selectedService?.price.toFixed(2)}</span>
                    </div>
                  )}

                </div>
              </div>
              
              <div className="customer-info-column">
                <PaymentForm 
                  customerInfo={{...customerInfo, price: selectedService.has_deposit ? (selectedService?.price * selectedService?.deposit_fraction).toFixed(2) : selectedService?.price.toFixed(2)}}
                  onCustomerInfoChange={onCustomerInfoChange}
                  onConfirmBooking={onConfirmBooking}
                  businessId={businessId}
                  workerId={selectedWorker?.id}
                  serviceId={selectedService?.id}
                  paymentCompleted={paymentCompleted}
                  onPaymentCompleted={onPaymentCompleted}
                  showPaymentForm={true}
                />
              </div>
            </div>
          </div>
        </Elements>
      ) : (
        <div className="booking-step">
          <h2>Confirm Your Booking</h2>
          <div className="loading-payment">
            <p>Setting up payment...</p>
          </div>
        </div>
      )  
    }

    </>
  )
}

export default BookingConfirmation